import Vue from 'vue';
import VueI18n from 'vue-i18n';
import JSCookie from 'js-cookie';
import en from './languages/en.json';
import ja from './languages/ja.json';
import config from '../config';

Vue.use(VueI18n);



export const i18n = new VueI18n({
    locale: JSCookie.get('app_locale') ? JSCookie.get('app_locale') : config.defaultLanguage,
    messages: {
        'en-US': en,
        'ja-JP': ja,
    }
});
